import { graphql, HttpResponse } from 'msw'
import { type EnrollmentAccountNameData, type EnrollmentAccountNameSubmitOutput } from '../../../models'

export const getEnrollmentAccountNameDataMock: EnrollmentAccountNameData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/account-name/traditional-ira',
  enrollmentData: {
    recommendation: {
      investment: {
        account: {
          accountNickname: 'Brokerage Account',
        },
      },
    },
  },
}

export const submitEnrollmentAccountNameDataMock: EnrollmentAccountNameSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/confirm-personal-info',
}

export const mockGetEnrollmentAccountNameData = graphql.mutation('getEnrollmentAccountNameData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentAccountNameDataMock } })
})

export const mockSubmitEnrollmentAccountNameData = graphql.mutation('submitEnrollmentAccountNameData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentAccountNameDataMock } })
})

export const mockEnrollmentAccountName = [mockGetEnrollmentAccountNameData, mockSubmitEnrollmentAccountNameData]
